import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'dot-prop';

@Pipe({
    name: 'unique',
    standalone: true
})
export class UniquePipe implements PipeTransform {
    transform(array: Array<any>, key?: string): Array<any> {
        const uniqueArray = [];
        for (let i = 0; i < array?.length; i++) {
            if (
                key
                    ? uniqueArray
                          .map((item) => get<any>(item, key))
                          .indexOf(get<any>(array[i], key)) === -1
                    : uniqueArray.indexOf(array[i]) === -1
            ) {
                uniqueArray.push(array[i]);
            }
        }
        return uniqueArray;
    }
}
